import React from 'react'
import LandlordMontlyRent from '../Components/Monthly rent/Landlord/LandlordMontlyRent'

const LandlordMonthlyRentPage = () => {
  return (
    <LandlordMontlyRent />
  )
}

export default LandlordMonthlyRentPage